import githubIcon from '@/assets/images/github.svg';
import googleIcon from '@/assets/images/google.svg';
import { DMButton } from '@/components/button';
import { DMLink } from '@/components/link';
import { useTranslations } from 'next-intl';
import SocialAuthButton from './social-auth-button';

type SocialAuthProps = {
  pageType: 'login' | 'signup' | 'forgotpassword';
  onModalCallBack?: () => void;
};

export const SocialAuth = ({ pageType, onModalCallBack }: SocialAuthProps) => {
  const t = useTranslations('Auth');

  return (
    <div className='w-full flex flex-col gap-4'>
      {/* <OrLine /> */}

      <div className='flex justify-between items-center'>
        {process.env.NEXT_PUBLIC_SERVER === 'vercel' && (
          <div>
            {onModalCallBack ? (
              <DMButton
                variant='text'
                className='text-sm font-semibold text-center w-full text-gray-300 !p-0'
                onClick={onModalCallBack}
              >
                {pageType === 'login' ? 'No account? Create' : 'Have account? Login'}
              </DMButton>
            ) : (
              <DMLink
                href={`/${pageType === 'login' ? 'signup' : 'login'}`}
                variant='text'
                className='text-sm font-semibold mt-4 text-center w-full text-gray-300'
              >
                {pageType === 'login' ? 'No account? Create' : 'Have account? Login'}
              </DMLink>
            )}
          </div>
        )}
        <div className='flex flex-col gap-4 justify-center text-center items-center mx-auto'>
          <SocialAuthButton
            authType='google'
            icon={googleIcon}
            label={t(`${pageType}_option_google`)}
          />

          <SocialAuthButton
            authType='github'
            icon={githubIcon}
            label={t(`${pageType}_option_github`)}
          />
        </div>
      </div>
    </div>
  );
};
